import React from "react";
import ProductGroupConfigDropdown from "../../../containers/ProductGroupConfigDropdown";

export default function LtrTabDropdowns() {
  return (
        <ProductGroupConfigDropdown />
  );
} 